import React from 'react'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import { ShopByTires } from 'components/VehicleConfigurator'

const BOTSearchTiresBySizePanel = props =>
  <Wrapper>
    <Title data-at-heading="search-tires-by-size">Shop by tire size</Title>
    <CustomShopByTires { ...props } />
  </Wrapper>

export default BOTSearchTiresBySizePanel

const Wrapper = styled.div`
  padding-top: 18px;
  border: solid ${Theme.colors.light_grey};
  border-width: 3px 0;
  border-top-color: ${Theme.colors.red};
  ${Media.desktop`
    border-width: 3px 1px 1px;
  `}
`

const Title = styled.div`
  padding: 0 23px;
  color: ${Theme.colors.red};
  text-align: right;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(14, 600)}
`

const CustomShopByTires = styled(ShopByTires)`
  margin-top: 34px;
  ${Media.desktop`
    min-height: 308px;
  `}
`
